import { DefaultErrorPage } from '@odmonorepo/core-components';
import { FormattedMessage } from 'react-intl';

// SCC-brute-force (PARTNER_ISO) customers can reach the offer email page before their
// offer is priced; studios mock-up shows this messaging instead of a generic/loading error.
export const ContactOndeckPartner = () => (
  <DefaultErrorPage
    title={<FormattedMessage id="customError.contactOndeckPartner.title" />}
    message={<FormattedMessage id="customError.contactOndeckPartner.message" />}
    customerServiceCard={false}
    hasHeader={false}
  />
);

export default ContactOndeckPartner;
